export default __webpack_public_path__ + "static/media/Grupo 160.66cd7048.svg";